import classNames from 'classnames'
import { forwardRef, type ReactNode, type Ref } from 'react'
import { type TextStylesType, Typography } from 'shared/ui/Typography/Typography'
import { Checkbox } from 'shared/ui/Checkbox/Checkbox'
import { Icon } from 'shared/ui/Icon'
import { type ITooltipProps, Tooltip } from 'shared/ui/Tooltip'
import styles from './styles.module.scss'

export type InputCheckboxProps = {
  checked: boolean
  readOnly?: boolean
  disabled?: boolean
  onChecked: () => void
  label?: ReactNode
  customLabel?: ReactNode
  className?: string
  color?: string
  variant?: TextStylesType
  questionTooltipProps?: ITooltipProps
  tooltipProps?: ITooltipProps
  checkboxClassName?: string
}

export const InputCheckboxRef = (
  {
    checked,
    onChecked,
    label = '',
    customLabel,
    className,
    color,
    questionTooltipProps,
    tooltipProps,
    variant = 'text-input-field',
    checkboxClassName,
    readOnly,
    disabled,
  }: InputCheckboxProps,
  ref: Ref<HTMLInputElement>
) => {
  const isDisabled = !!disabled
  const isSelectBlocked = isDisabled || readOnly

  const content = (
    <div
      className={classNames(styles.wrap, { [styles.disabled]: isDisabled }, className)}
      onClick={() => {
        if (isSelectBlocked) {
          return
        }
        onChecked()
      }}
    >
      <Checkbox
        checked={checked}
        size={16}
        ref={ref}
        className={checkboxClassName}
        disabled={isSelectBlocked}
      />
      {customLabel && customLabel}
      {!customLabel && (
        <Typography variant={variant} ariaLabel={'label'} color={color}>
          {label}
        </Typography>
      )}
      {questionTooltipProps && (
        <Tooltip placement={'top'} className={styles.tooltip} {...questionTooltipProps}>
          <Icon icon={'question'} color={'var(--content-neutral-primary)'} fontSize={14} />
        </Tooltip>
      )}
    </div>
  )

  if (tooltipProps) {
    return <Tooltip {...tooltipProps}>{content}</Tooltip>
  }

  return content
}

export const InputCheckbox = forwardRef(InputCheckboxRef)
